<template>
    <div class="container header-ident d-flex justify-content-between" style="padding-top:5px;padding-bottom:5px">
        <div style="min-width:96px;">
            <img src="../../assets/WDBC-Logo-125x96.png" class="hidden-print img-responsive">
            <img src="../../assets/WDBC-Logo-93x79.png" class="visible-print">
        </div>
        <div style="text-align:right;">
            <img :src="headerImageUrl" style="max-height:96px;" class="hidden-print img-responsive">
            <img :src="headerImageUrl" style="max-height:79px;" class="visible-print">
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import CurrentUser from "../../mixins/CurrentUser";

export default {
    mixins: [CurrentUser],
    computed:{
        ...mapState(['loggedIn']),
        headerImageUrl: function() {
            if (this.loggedIn && this.currentUser.force.header_image != '') {
                return this.currentUser.force.header_image_url;
            }
            return window.api.url + 'img/PoliceLogo.jpg';
        }
    }
}
</script>